var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-wrapper",style:(_vm.height)},[_c('span',[_c('a',{attrs:{"href":""}},[_vm._v(_vm._s(_vm.imgTitle))])]),_c('img',{attrs:{"src":_vm.imgURL,"width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }